import { usePagesUpdate } from 'shared/libs/hooks/usePagesUpdate'
import { OrdersStatusKey } from 'shared/types/Common'

import { Key, useEffect } from 'react'

import OrderColumnItem from 'modules/Orders/components/OrderColumnItem'
import { useOrderObserve } from 'modules/Orders/hooks/useOrderObserve'
import { useOrders } from 'modules/Orders/hooks/useOrders'
import { OrdersStatusValue } from 'modules/Orders/types'

import { Skeleton } from 'shared/ui/Skeleton'

interface Props {
  status: OrdersStatusKey
  columnStatus: OrdersStatusValue
}

const OrderColumn = ({ status, columnStatus }: Props) => {
  const { color, title } = columnStatus
  const {
    ordersData,
    isFetching,
    limit,
    count,
    intersectionObserverIndex,
    handeChangeOrdersParams,
    lastPage,
    pages,
    isUpdate,
    isAllReset,
  } = useOrders({ status })

  const { updateIsValid, refreshPageValidity, resetPagesRelevance } =
    usePagesUpdate({ pages, interval: 15000 })
  const { createObserver, nextDataCount, setNextDataCount, currentPage } =
    useOrderObserve({
      count: count ?? null,
      intersectionObserverIndex,
      isFetching,
      lastPage: lastPage ?? null,
      limit: limit,
      ordersData,
      status,
    })

  useEffect(() => {
    if (limit) setNextDataCount(limit)
  }, [limit])

  useEffect(() => {
    if (
      currentPage &&
      updateIsValid &&
      updateIsValid[String(currentPage)] === false
    ) {
      handeChangeOrdersParams({
        page: currentPage,
        limit: 10,
        status,
        isUpdate: true,
        isFetching: true,
      })
      refreshPageValidity(String(currentPage))
    }
  }, [currentPage, updateIsValid])

  useEffect(() => {
    if (isAllReset) {
      resetPagesRelevance()
    }
  }, [isAllReset])

  return (
    <div className="flex flex-col gap-3 min-w-[270px]">
      <div
        className={`pt-[5px] leading-[20px] text-medium text-[16px] border border-light_gray_3 rounded-[8px] overflow-hidden`}
        style={{ backgroundColor: color }}
      >
        <span className="flex px-[16px] pt-[7px] pb-[12px] leading-none text-dark bg-white">
          {title}
        </span>
      </div>
      <div className="flex flex-col gap-[8px]">
        {ordersData &&
          ordersData.map((orderItem, index) => {
            return (
              <div
                ref={limit ? createObserver(index) : null}
                key={orderItem.id}
                data-index={index}
              >
                <OrderColumnItem orderItem={orderItem} />
              </div>
            )
          })}
        {isFetching &&
          !isUpdate &&
          nextDataCount &&
          Array.from({ length: nextDataCount }, (_, index: Key) => (
            <Skeleton
              key={index}
              active
              className="h-[160px] px-[12px] pt-[14px] pb-[10px] bg-white border border-light_gray_3 rounded-[16px]"
            />
          ))}
      </div>
    </div>
  )
}

export default OrderColumn
